import { useBlocker, useBeforeUnload } from 'react-router-dom'
import React from 'react'

/**
 * Hook to warn the user about unsaved changes before they navigate or close the page.
 * @param {boolean} hasUnsavedChanges - Indicates if there are unsaved changes.
 * @returns {object} - An object with the 'blocker' state and methods to proceed or cancel.
 */
export const useUnsavedChangesWarning = (hasUnsavedChanges: boolean) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname
  )

  useBeforeUnload(
    React.useCallback(
      (event: BeforeUnloadEvent) => {
        if (hasUnsavedChanges) {
          event.preventDefault()
          event.returnValue = ''
        }
      },
      [hasUnsavedChanges]
    )
  )

  return blocker
}
